/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Operator applied between left and right (currently only + and -)
 */
export const RollOperator = {
    Plus: '+',
    Minus: '-'
} as const;
export type RollOperator = typeof RollOperator[keyof typeof RollOperator];

